import { Column, FileManagerRow, FMColumn } from '../model';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { Type } from '../../../../general/modules/filter/dataModel';
import { TeamCell } from '../components/cells/TeamCell';

export const teamCol: FMColumn<Type.ID> = {
  key: Column.team,
  dataKey: Column.team,
  title: 'Team',
  width: 120,
  sortable: true,
  cellRenderer: TeamCell,
  className: 'ch-file-manager__cell_team',
  filter: Type.ID,
  plugins: [FilterEnumContainer],
  getter: (n: FileManagerRow) => {
    return n.creative?.team?.name ?? '<no team>';
  },
  toDisplayString: (n: FileManagerRow) => {
    return n.creative?.team?.name ?? '<no team>';
  },
};
